"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const NotificationsManager_1 = __importDefault(require("./NotificationsManager"));
exports.default = NotificationsManager_1.default;
